import { useQuery } from '@tanstack/react-query';
import { listResource } from '@diggens/api-client';

export interface AttachmentFile {
  name: string;
  size: number;
  mimeType: string;
  url: string;
}

export function useAttachments(nodeId: string) {
  return useQuery({
    queryKey: ['attachments', nodeId],
    queryFn: async () => {
      const { data } = await listResource('attachments', { node_id: nodeId });
      return data;
    },
    enabled: !!nodeId,
  });
}
